import { render, staticRenderFns } from "./BasicMain.vue?vue&type=template&id=21bbea06&scoped=true&"
import script from "./BasicMain.vue?vue&type=script&lang=js&"
export * from "./BasicMain.vue?vue&type=script&lang=js&"
import style0 from "./BasicMain.vue?vue&type=style&index=0&id=21bbea06&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21bbea06",
  null
  
)

export default component.exports